import React, { useState, useEffect } from 'react';
import './LogEntryModal.css';

function LogEntryModal({ show, onClose, onSubmit, bateauType, nbMoteurs, currentPosition, currentCap }) {
  const [step, setStep] = useState(1);
  const [meteo, setMeteo] = useState('');
  const [vent, setVent] = useState('');
  const [mer, setMer] = useState('');
  const [cap, setCap] = useState('');
  const [heuresMoteur, setHeuresMoteur] = useState(nbMoteurs > 1 ? ['', ''] : ['']);
  const [voilure, setVoilure] = useState('');
  const [remarques, setRemarques] = useState('');
  const [position, setPosition] = useState({ lat: '', lng: '' });

  useEffect(() => {
    if (currentPosition) {
      setPosition({
        lat: currentPosition.lat.toFixed(6),
        lng: currentPosition.lng.toFixed(6)
      });
    }
  }, [currentPosition]);

  useEffect(() => {
    if (currentCap) {
      setCap(Math.round(currentCap).toString());
    }
  }, [currentCap]);

  if (!show) return null;

  const handleNext = () => {
    if (step < 5) setStep(step + 1);
  };

  const handlePrev = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Jouer le son
    const audio = new Audio('/notification-sound.mp3');
    audio.play().catch(err => console.log('Erreur son:', err));
    
    onSubmit({
      meteo,
      vent,
      mer,
      cap: cap || null,
      heures_moteur: heuresMoteur.filter(h => h !== ''),
      voilure: bateauType === 'voilier' ? voilure : null,
      remarques,
      position: position.lat && position.lng ? position : null
    });
    
    // Reset
    setStep(1);
    setMeteo('');
    setVent('');
    setMer('');
    setCap('');
    setHeuresMoteur(nbMoteurs > 1 ? ['', ''] : ['']);
    setVoilure('');
    setRemarques('');
    setPosition({ lat: '', lng: '' });
    
    onClose();
  };

  const handleMoteurChange = (index, value) => {
    const newHeures = [...heuresMoteur];
    newHeures[index] = value;
    setHeuresMoteur(newHeures);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content log-entry-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>📖 Carnet de bord</h2>
          <button onClick={onClose} className="close-btn">✕</button>
        </div>

        <div className="progress-bar">
          <div className="progress" style={{ width: `${(step / 5) * 100}%` }}></div>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div className="step-indicator">
            Étape {step} / 5
          </div>

          {/* ÉTAPE 1 : Météo */}
          {step === 1 && (
            <div className="form-group">
              <label>☁️ Conditions météo</label>
              <select 
                value={meteo} 
                onChange={(e) => setMeteo(e.target.value)}
                required
              >
                <option value="">Sélectionner...</option>
                <option value="Ensoleillé">☀️ Ensoleillé</option>
                <option value="Nuageux">⛅ Nuageux</option>
                <option value="Couvert">☁️ Couvert</option>
                <option value="Pluie">🌧️ Pluie</option>
                <option value="Orage">⛈️ Orage</option>
                <option value="Brouillard">🌫️ Brouillard</option>
              </select>
            </div>
          )}

          {/* ÉTAPE 2 : Vent et Mer */}
          {step === 2 && (
            <>
              <div className="form-group">
                <label>💨 Force du vent</label>
                <select 
                  value={vent} 
                  onChange={(e) => setVent(e.target.value)}
                  required
                >
                  <option value="">Sélectionner...</option>
                  <option value="Calme (0-1)">Calme (0-1 Beaufort)</option>
                  <option value="Légère brise (2-3)">Légère brise (2-3)</option>
                  <option value="Petite brise (4)">Petite brise (4)</option>
                  <option value="Jolie brise (5)">Jolie brise (5)</option>
                  <option value="Bonne brise (6)">Bonne brise (6)</option>
                  <option value="Vent frais (7)">Vent frais (7)</option>
                  <option value="Grand frais (8+)">Grand frais (8+)</option>
                </select>
              </div>

              <div className="form-group">
                <label>🌊 État de la mer</label>
                <select 
                  value={mer} 
                  onChange={(e) => setMer(e.target.value)}
                  required
                >
                  <option value="">Sélectionner...</option>
                  <option value="Calme">Calme (0-0.5m)</option>
                  <option value="Belle">Belle (0.5-1.25m)</option>
                  <option value="Peu agitée">Peu agitée (1.25-2.5m)</option>
                  <option value="Agitée">Agitée (2.5-4m)</option>
                  <option value="Forte">Forte (4-6m)</option>
                  <option value="Très forte">Très forte (6m+)</option>
                </select>
              </div>
            </>
          )}

          {/* ÉTAPE 3 : Cap + Heures moteur */}
          {step === 3 && (
            <>
              <div className="form-group">
                <label>🧭 Cap (°)</label>
                <input
                  type="number"
                  value={cap}
                  onChange={(e) => setCap(e.target.value)}
                  placeholder="Ex: 180"
                  min="0"
                  max="360"
                />
                <small>Cap du bateau (0-360°) {currentCap && '- Détecté automatiquement'}</small>
              </div>

              {bateauType === 'moteur' || bateauType === 'catamaran' ? (
                <>
                  <label>⚙️ Heures moteur</label>
                  {heuresMoteur.map((heure, index) => (
                    <div key={index} className="form-group">
                      <input
                        type="number"
                        step="0.1"
                        value={heure}
                        onChange={(e) => handleMoteurChange(index, e.target.value)}
                        placeholder={`Moteur ${index + 1} (heures)`}
                      />
                    </div>
                  ))}
                </>
              ) : null}
            </>
          )}

          {/* ÉTAPE 4 : Voilure (si voilier) */}
          {step === 4 && bateauType === 'voilier' && (
            <div className="form-group">
              <label>⛵ Voilure</label>
              <textarea
                value={voilure}
                onChange={(e) => setVoilure(e.target.value)}
                placeholder="Ex: Grand-voile + Génois"
                rows="3"
              />
            </div>
          )}

          {/* ÉTAPE 5 : Position et remarques */}
          {step === 5 && (
            <>
              <div className="form-group">
                <label>📍 Position GPS</label>
                <input
                  type="text"
                  value={position.lat}
                  onChange={(e) => setPosition({ ...position, lat: e.target.value })}
                  placeholder="Latitude"
                />
                <input
                  type="text"
                  value={position.lng}
                  onChange={(e) => setPosition({ ...position, lng: e.target.value })}
                  placeholder="Longitude"
                  style={{ marginTop: '10px' }}
                />
                <small>{currentPosition && '📍 Position détectée automatiquement'}</small>
              </div>

              <div className="form-group">
                <label>📝 Remarques</label>
                <textarea
                  value={remarques}
                  onChange={(e) => setRemarques(e.target.value)}
                  placeholder="Observations, événements particuliers..."
                  rows="4"
                />
              </div>
            </>
          )}

          <div className="form-actions">
            {step > 1 && (
              <button type="button" onClick={handlePrev} className="btn btn-secondary">
                ← Précédent
              </button>
            )}
            
            {step < 5 ? (
              <button type="button" onClick={handleNext} className="btn btn-primary">
                Suivant →
              </button>
            ) : (
              <button type="submit" className="btn btn-primary">
                ✅ Enregistrer
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default LogEntryModal;